module.exports = __webpack_public_path__ + "img/Mask Group 141.eb5b0017.svg";